<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance_wallet</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Saldos de Usuarios - Wallet Cardex</h1>
  </div>

  <!-- Resumen -->
  <div *ngIf="summary" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #3b82f6;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total Usuarios</h3>
      <p class="text-2xl font-bold text-gray-800 mt-1">{{ summary.totalUsers }}</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #16a34a;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total USDT Abonados</h3>
      <p class="text-2xl font-bold mt-1" style="color: #16a34a;">{{ formatUSDT(summary.totalUsdtAbonados) }}</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #dc2626;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total USDT Debitados</h3>
      <p class="text-2xl font-bold mt-1" style="color: #dc2626;">{{ formatUSDT(summary.totalUsdtDebitados) }}</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #34d399;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Saldo Total Disponible</h3>
      <p class="text-2xl font-bold mt-1" style="color: #1C593D;">{{ formatUSDT(summary.totalSaldoDisponible) }}</p>
    </div>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="filters.startDate" name="startDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Fin</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="filters.endDate" name="endDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario ID</mat-label>
            <input matInput [(ngModel)]="filters.userId" name="userId" placeholder="ID del usuario">
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
          <button type="button" (click)="exportToExcel()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">download</mat-icon>
            Exportar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando saldos de usuarios...</span>
  </div>

  <!-- Error -->
  <div *ngIf="errorMsg" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    {{ errorMsg }}
  </div>

  <!-- Success -->
  <div *ngIf="successMsg" class="success-snackbar mb-4">
    <mat-icon>check_circle</mat-icon>
    {{ successMsg }}
  </div>

  <!-- Card Tabla Saldos -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Saldos de Usuarios
      </h2>
    </div>

    <!-- Tabla Desktop: hidden lg:block -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let user">
            <div class="text-xs font-medium">{{ user.userName || 'Sin nombre' }}</div>
            <div class="text-xs text-gray-400">{{ user.userEmail || 'Sin email' }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>Usuario ID</th>
          <td mat-cell *matCellDef="let user"><span class="text-xs font-mono">{{ user.userId }}</span></td>
        </ng-container>

        <ng-container matColumnDef="userEmail">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let user"><span class="text-xs">{{ user.userEmail || '-' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="usdtAbonados">
          <th mat-header-cell *matHeaderCellDef>USDT Abonados</th>
          <td mat-cell *matCellDef="let user"><span class="text-xs font-semibold" style="color: #16a34a;">{{ formatUSDT(user.usdtAbonados) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="usdtDebitados">
          <th mat-header-cell *matHeaderCellDef>USDT Debitados</th>
          <td mat-cell *matCellDef="let user"><span class="text-xs font-semibold" style="color: #dc2626;">{{ formatUSDT(user.usdtDebitados) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="saldoDisponible">
          <th mat-header-cell *matHeaderCellDef>Saldo Disponible</th>
          <td mat-cell *matCellDef="let user">
            <span class="text-xs font-bold"
              [style.color]="user.saldoDisponible > 0 ? '#16a34a' : user.saldoDisponible < 0 ? '#dc2626' : '#6b7280'">
              {{ formatUSDT(user.saldoDisponible) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastMovementDate">
          <th mat-header-cell *matHeaderCellDef>&Uacute;ltima Transacci&oacute;n</th>
          <td mat-cell *matCellDef="let user"><span class="text-xs text-gray-600">{{ formatDate(user.lastMovementDate) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 90px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let user" style="width: 90px; text-align: center;">
            <div class="flex items-center justify-center gap-1">
              <button title="Agregar Saldo Manual" (click)="openManualCreditModal(user, $event)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">add_circle</mat-icon>
              </button>
              <button title="Quitar Saldo Manual" (click)="openManualDebitModal(user, $event)"
                [disabled]="user.saldoDisponible <= 0"
                [style.opacity]="user.saldoDisponible <= 0 ? '0.4' : '1'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">remove_circle</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile: lg:hidden -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let user of dataSource.data; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="text-xs font-semibold text-gray-700 truncate">{{ user.userName || 'Sin nombre' }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold"
              [style.color]="user.saldoDisponible > 0 ? '#16a34a' : user.saldoDisponible < 0 ? '#dc2626' : '#6b7280'">
              {{ formatUSDT(user.saldoDisponible) }}
            </span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Usuario ID</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5">{{ user.userId }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Email</span>
              <p class="text-gray-700 font-medium mt-0.5 truncate">{{ user.userEmail || '-' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">USDT Abonados</span>
              <p class="font-semibold mt-0.5" style="color: #16a34a;">{{ formatUSDT(user.usdtAbonados) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">USDT Debitados</span>
              <p class="font-semibold mt-0.5" style="color: #dc2626;">{{ formatUSDT(user.usdtDebitados) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Saldo Disponible</span>
              <p class="font-bold mt-0.5"
                [style.color]="user.saldoDisponible > 0 ? '#16a34a' : user.saldoDisponible < 0 ? '#dc2626' : '#6b7280'">
                {{ formatUSDT(user.saldoDisponible) }}
              </p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">&Uacute;ltima Transacci&oacute;n</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatDate(user.lastMovementDate) }}</p>
            </div>
          </div>
          <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
            <button title="Agregar Saldo" (click)="openManualCreditModal(user, $event)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #16a34a;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">add_circle</mat-icon>
              Agregar
            </button>
            <button title="Quitar Saldo" (click)="openManualDebitModal(user, $event)"
              [disabled]="user.saldoDisponible <= 0"
              [style.opacity]="user.saldoDisponible <= 0 ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">remove_circle</mat-icon>
              Quitar
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!dataSource.data.length && !loading" class="text-center text-gray-400 py-8">
        No hay usuarios con saldos para mostrar
      </div>
    </div>

    <!-- Paginaci&oacute;n -->
    <div class="p-4">
      <mat-paginator
        [length]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 20, 50, 100]"
        (page)="loadWalletBalances($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>

    <!-- No hay datos (desktop) -->
    <div *ngIf="!dataSource.data.length && !loading" class="hidden lg:block text-center py-8 text-gray-400">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">inbox</mat-icon>
      <p class="mt-2">No hay usuarios con saldos para mostrar</p>
      <p class="text-sm">Intenta ajustar los filtros de b&uacute;squeda</p>
    </div>
  </div>
</div>

<!-- Modal de Quitar Saldo Manual -->
<div *ngIf="showManualDebitModal"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeManualDebitModal()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header gradiente rojo/naranja -->
    <div style="background: linear-gradient(135deg, #fef2f2, #fee2e2); padding: 16px 24px; border-bottom: 2px solid #fecaca;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #991b1b; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #dc2626;">remove_circle</mat-icon>
        Quitar Saldo Manual de USDT
      </h2>
    </div>

    <div class="p-5">
      <!-- Error message -->
      <div *ngIf="errorMsg" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsg }}</span>
      </div>

      <div class="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-orange-600 text-sm">warning</mat-icon>
        <div class="text-orange-700 text-sm">
          <p class="font-semibold">&iquest;Est&aacute; seguro que desea quitar saldo manualmente?</p>
          <p class="text-xs mt-1">Esta acci&oacute;n quitar&aacute; USDT del saldo disponible del usuario y se registrar&aacute; en el cardex.</p>
        </div>
      </div>

      <div *ngIf="selectedUser" class="bg-gray-50 p-4 rounded-md border border-gray-200 mb-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Informaci&oacute;n del Usuario:</h4>
        <div class="text-sm space-y-2">
          <div class="bg-white p-3 rounded-md border border-blue-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-blue-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ selectedUser.userName || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ selectedUser.userEmail || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ selectedUser.userId }}</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between pt-2 border-t">
            <span class="text-gray-600 font-semibold">Saldo Disponible:</span>
            <span class="font-bold" style="color: #16a34a;">{{ formatUSDT(selectedUser.saldoDisponible) }}</span>
          </div>
        </div>
      </div>

      <form [formGroup]="manualDebitForm">
        <div class="mb-4">
          <label for="amount" class="block text-sm font-medium text-gray-700 mb-2">
            Monto a Quitar (USDT) <span class="text-red-500">*</span>
          </label>
          <input id="amount" type="text" inputmode="decimal" placeholder="Ej: 100,00"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitForm.get('amount')?.invalid && manualDebitForm.get('amount')?.touched"
            (input)="onAmountInput($event)" />
          <div *ngIf="manualDebitForm.get('amount')?.invalid && manualDebitForm.get('amount')?.touched" class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitForm.get('amount')?.errors?.['required']">El monto es requerido</span>
            <span *ngIf="manualDebitForm.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
            <span *ngIf="manualDebitForm.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. M&aacute;ximo 2 decimales.</p>
        </div>
        <div class="mb-4">
          <label for="reason" class="block text-sm font-medium text-gray-700 mb-2">
            Motivo <span class="text-red-500">*</span>
          </label>
          <textarea id="reason" formControlName="reason" rows="3"
            placeholder="Ej: Ajuste por error en dep&oacute;sito, correcci&oacute;n de saldo, retiro no procesado, etc."
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitForm.get('reason')?.invalid && manualDebitForm.get('reason')?.touched"></textarea>
          <div *ngIf="manualDebitForm.get('reason')?.invalid && manualDebitForm.get('reason')?.touched" class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitForm.get('reason')?.errors?.['required']">El motivo es requerido</span>
            <span *ngIf="manualDebitForm.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 5 caracteres</span>
          </div>
        </div>
      </form>
    </div>

    <div class="px-5 pb-5 flex flex-col sm:flex-row justify-center gap-3">
      <button type="button" (click)="executeManualDebit()"
        [disabled]="loading || manualDebitForm.invalid || isProcessingDebit || debitRetryAfterSeconds > 0"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        [style.opacity]="loading || manualDebitForm.invalid || isProcessingDebit || debitRetryAfterSeconds > 0 ? '0.5' : '1'"
        onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
        <mat-icon *ngIf="!isProcessingDebit && debitRetryAfterSeconds === 0" style="font-size: 18px; width: 18px; height: 18px; color: white;">remove_circle</mat-icon>
        <mat-icon *ngIf="debitRetryAfterSeconds > 0" style="font-size: 18px; width: 18px; height: 18px; color: white;">schedule</mat-icon>
        <mat-spinner diameter="16" *ngIf="isProcessingDebit"></mat-spinner>
        <span *ngIf="!isProcessingDebit && debitRetryAfterSeconds === 0">Quitar Saldo</span>
        <span *ngIf="isProcessingDebit">Procesando...</span>
        <span *ngIf="debitRetryAfterSeconds > 0">Espera {{ debitRetryAfterSeconds }}s</span>
      </button>
      <button type="button" (click)="closeManualDebitModal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Agregar Saldo Manual -->
<div *ngIf="showManualCreditModal"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeManualCreditModal()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header gradiente verde -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">add_circle</mat-icon>
        Agregar Saldo Manual de USDT
      </h2>
    </div>

    <div class="p-5">
      <!-- Error message -->
      <div *ngIf="errorMsg" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsg }}</span>
      </div>

      <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-blue-600 text-sm">info</mat-icon>
        <div class="text-blue-700 text-sm">
          <p class="font-semibold">&iquest;Est&aacute; seguro que desea agregar saldo manualmente?</p>
          <p class="text-xs mt-1">Esta acci&oacute;n agregar&aacute; USDT al saldo disponible del usuario y se registrar&aacute; en el cardex.</p>
        </div>
      </div>

      <div *ngIf="selectedUserCredit" class="bg-gray-50 p-4 rounded-md border border-gray-200 mb-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Informaci&oacute;n del Usuario:</h4>
        <div class="text-sm space-y-2">
          <div class="bg-white p-3 rounded-md border border-blue-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-blue-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ selectedUserCredit.userName || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ selectedUserCredit.userEmail || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ selectedUserCredit.userId }}</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between pt-2 border-t">
            <span class="text-gray-600 font-semibold">Saldo Actual:</span>
            <span class="font-bold text-gray-700">{{ formatUSDT(selectedUserCredit.saldoDisponible) }}</span>
          </div>
        </div>
      </div>

      <form [formGroup]="manualCreditForm">
        <div class="mb-4">
          <label for="amountCredit" class="block text-sm font-medium text-gray-700 mb-2">
            Monto a Agregar (USDT) <span class="text-red-500">*</span>
          </label>
          <input id="amountCredit" type="text" inputmode="decimal" placeholder="Ej: 100,00"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            [class.border-red-500]="manualCreditForm.get('amount')?.invalid && manualCreditForm.get('amount')?.touched"
            (input)="onAmountInputCredit($event)" />
          <div *ngIf="manualCreditForm.get('amount')?.invalid && manualCreditForm.get('amount')?.touched" class="text-red-500 text-xs mt-1">
            <span *ngIf="manualCreditForm.get('amount')?.errors?.['required']">El monto es requerido</span>
            <span *ngIf="manualCreditForm.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
            <span *ngIf="manualCreditForm.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. M&aacute;ximo 2 decimales.</p>
        </div>
        <div class="mb-4">
          <label for="reasonCredit" class="block text-sm font-medium text-gray-700 mb-2">
            Motivo <span class="text-red-500">*</span>
          </label>
          <textarea id="reasonCredit" formControlName="reason" rows="3"
            placeholder="Ej: Dep&oacute;sito no registrado, correcci&oacute;n de saldo, bonificaci&oacute;n, compensaci&oacute;n, etc."
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            [class.border-red-500]="manualCreditForm.get('reason')?.invalid && manualCreditForm.get('reason')?.touched"></textarea>
          <div *ngIf="manualCreditForm.get('reason')?.invalid && manualCreditForm.get('reason')?.touched" class="text-red-500 text-xs mt-1">
            <span *ngIf="manualCreditForm.get('reason')?.errors?.['required']">El motivo es requerido</span>
            <span *ngIf="manualCreditForm.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 5 caracteres</span>
          </div>
        </div>
      </form>
    </div>

    <div class="px-5 pb-5 flex flex-col sm:flex-row justify-center gap-3">
      <button type="button" (click)="executeManualCredit()"
        [disabled]="loading || manualCreditForm.invalid || isProcessingCredit || creditRetryAfterSeconds > 0"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        [style.opacity]="loading || manualCreditForm.invalid || isProcessingCredit || creditRetryAfterSeconds > 0 ? '0.5' : '1'"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon *ngIf="!isProcessingCredit && creditRetryAfterSeconds === 0" style="font-size: 18px; width: 18px; height: 18px; color: white;">add_circle</mat-icon>
        <mat-icon *ngIf="creditRetryAfterSeconds > 0" style="font-size: 18px; width: 18px; height: 18px; color: white;">schedule</mat-icon>
        <mat-spinner diameter="16" *ngIf="isProcessingCredit"></mat-spinner>
        <span *ngIf="!isProcessingCredit && creditRetryAfterSeconds === 0">Agregar Saldo</span>
        <span *ngIf="isProcessingCredit">Procesando...</span>
        <span *ngIf="creditRetryAfterSeconds > 0">Espera {{ creditRetryAfterSeconds }}s</span>
      </button>
      <button type="button" (click)="closeManualCreditModal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>
